import {
  DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_BEGIN,
  DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_SUCCESS,
  DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_FAILURE,
  DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function xataSaveExternalDatabase(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_BEGIN,
    });
    const { projectId, projectVersion } = args;
    const header = builderSurfaceJsonContentHeader(projectId);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${projectVersion}/xata/save-externaldb`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissXataSaveExternalDatabaseError() {
  return {
    type: DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_BEGIN:
      return {
        ...state,
        xataSaveExternalDatabasePending: true,
        xataSaveExternalDatabaseError: null,
      };

    case DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_SUCCESS:
      return {
        ...state,
        xataSaveExternalDatabasePending: false,
        xataSaveExternalDatabaseError: null,
        externalDbUuidXata: action.data.uuid,
      };

    case DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_FAILURE:
      return {
        ...state,
        xataSaveExternalDatabasePending: false,
        xataSaveExternalDatabaseError: action.data.error,
      };

    case DATA_CONNECTOR_XATA_SAVE_EXTERNAL_DATABASE_DISMISS_ERROR:
      return {
        ...state,
        xataSaveExternalDatabaseError: null,
      };

    default:
      return state;
  }
}
